import styled from 'styled-components'

interface IGridContainerProps {
  // cols
  cols?: number
  tabletCols?: number
  desktopCols?: number
  largeDesktopCols?: number
  // grid gaps
  gridGap?: number
  gridColumnGap?: number
  gridRowGap?: number
  tabletGridGap?: number
  tabletGripGap?: number
  desktopGridGap?: number
  largeDesktopGridGap?: number
  removeGridGap?: boolean
  // item min-max widths
  minWidth?: number
  maxWidth?: number
  tabletMinWidth?: number
  tabletMaxWidth?: number
  desktopMinWidth?: number
  desktopMaxWidth?: number
  largeDesktopMinWidth?: number
  largeDesktopMaxWidth?: number
  // internal alignment
  alignItems?: string
  justifyContent?: string
}
const GridContainer = styled.div<IGridContainerProps>`
  /* IE base */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  /* modern browser progressive enhancement */
  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(
      ${props => props.cols || 1},
      minmax(${props => props.minWidth || 50}px, ${props => props.maxWidth || 350}px)
    );
    grid-column-gap: ${props => props.gridColumnGap || props.gridGap || 10}px;
    grid-row-gap: ${props => props.gridRowGap || props.gridGap || 34}px;
    justify-content: ${props => props.justifyContent || 'space-between'};
    align-content: ${props => props.alignItems || 'space-around'};
    ${props => props.removeGridGap && 'grid-column-gap: 0px; grid-row-gap: 0px;'}

    @media (min-width: ${props => props.theme.metrics.tablet}px) {
      grid-template-columns: repeat(
        ${props => props.tabletCols || 3},
        minmax(
          ${props => props.tabletMinWidth || props.minWidth || 50}px,
          ${props => props.tabletMaxWidth || props.maxWidth || 400}px
        )
      );
      grid-column-gap: ${props =>
    props.gridColumnGap || props.tabletGridGap || props.gridGap || 10}px;
      grid-row-gap: ${props => props.gridRowGap || props.tabletGridGap || props.gridGap || 20}px;
      ${props => props.removeGridGap && 'grid-column-gap: 0px; grid-row-gap: 0px;'}
    }

    @media (min-width: ${props => props.theme.metrics.desktop}px) {
      grid-template-columns: repeat(
        ${props => props.desktopCols || 4},
        minmax(
          ${props => props.desktopMinWidth || props.minWidth || 50}px,
          ${props => props.desktopMaxWidth || props.maxWidth || 400}px
        )
      );
      grid-column-gap: ${props =>
    props.gridColumnGap || props.desktopGridGap || props.gridGap || 10}px;
      grid-row-gap: ${props => props.gridRowGap || props.desktopGridGap || props.gridGap || 20}px;
      ${props => props.removeGridGap && 'grid-column-gap: 0px; grid-row-gap: 0px;'}
    }

    @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
      grid-template-columns: repeat(
        ${props => props.largeDesktopCols || 5},
        minmax(
          ${props => props.largeDesktopMinWidth || props.minWidth || 50}px,
          ${props => props.largeDesktopMaxWidth || props.maxWidth || 400}px
        )
      );
      grid-column-gap: ${props =>
    props.gridColumnGap || props.largeDesktopGridGap || props.gridGap || 10}px;
      grid-row-gap: ${props =>
    props.gridRowGap || props.largeDesktopGridGap || props.gridGap || 20}px;
      ${props => props.removeGridGap && 'grid-column-gap: 0px; grid-row-gap: 0px;'}
    }
  }
`

export default GridContainer
